import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeleteComplianceRecordMutation } from "../graphql/mutations";
import type {
  DeleteComplianceRecordMutationType,
  DeleteComplianceRecordMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeleteComplianceRecordMutation = (
  options?: MutationHookOptions<
    DeleteComplianceRecordMutationType,
    DeleteComplianceRecordMutationVariablesType
  >
) => {
  return useMutation<
    DeleteComplianceRecordMutationType,
    DeleteComplianceRecordMutationVariablesType
  >(DeleteComplianceRecordMutation, options);
};
